import React from "react";
import "./button.css";

export default function ButtonGreen({
    type,
    text,
    disabled,
    loading,
    onClick,
    className = "",
}) {
    const isDisabled = disabled || loading;
    return (
        <div>
            <button
                type={type}
                className={`add-button-green ${className} rounded-pill d-inline-flex align-items-center justify-content-center`}
                disabled={isDisabled}
                onClick={onClick}>
                {loading && (
                    <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                    />
                )}
                {text}
            </button>
        </div>
    );
}

